import * as types from '../actions/actionTypes';
import { isShippingFree } from './prices';

export function changeLocale(state, action, languages) {
    switch (action.type) {

        case types.LOCALE_CHANGED:
            return Object.assign({}, languages[action.currentLanguage]);

        case types.LOCALE_SETTED_FROM_URI:
            return Object.assign({}, languages[action.language]);

        default:
            return state;
    }
}

export const getUriLangCode = state => {
    const { code } = state.stolo.i18n.currentLanguage;
    return code === 'de' ? null : code;
};

export const getCurrentLangCode = state =>
    state.stolo.i18n.currentLanguage.code;

export const getCurrentLocale = state =>
    state.stolo.i18n.currentLanguage.locale;

export const languageHydrator = (state = 'lang', action) => state;

export const getMessage = (state, id) => state.stolo.i18n.currentLanguage.messages[id] || null;

export const getCurrentPriceActionLabel = state => {
    if (isShippingFree) {
        return {
            id: 'SHIPPING_FREE_LABEL',
        };
    }
    return {
        id: 'CURRENT_PRICE_ACTION_LABEL',
    };
};



// WEBPACK FOOTER //
// ./src/reducers/i18n.js